import MedicationStatusCell from "./MedicationStatusCell";

export default MedicationStatusCell;